import { t } from "@/i18n-js/instance";
import { useIsPropertiesPanelRevampEnabled } from "@circle-react-shared/BuilderUI/Hooks/useIsPropertiesPanelRevamp";
import { Typography } from "../../../uikit/Typography";
import { usePickerContext } from "../../pickerContext";
import { Swatches } from "../ThemeColors/Swatches";

export const CustomColors = () => {
  const { customColors } = usePickerContext();
  const isPropertiesPanelV2 = useIsPropertiesPanelRevampEnabled();

  if (!customColors) {
    return null;
  }

  if (isPropertiesPanelV2) {
    return (
      <div className="flex w-full flex-col items-start justify-start gap-2">
        <Typography.LabelXs weight="semibold">
          {t("color_picker_v2.theme_picker.my_colors")}
        </Typography.LabelXs>
        <Swatches />
      </div>
    );
  }

  return (
    <div className="flex w-full flex-col items-start justify-start gap-3 px-4 pt-4">
      <Typography.LabelXs color="text-default" weight="medium">
        {t("color_picker_v2.theme_picker.my_colors")}
      </Typography.LabelXs>
      <Swatches />
    </div>
  );
};
